import { Component } from '@angular/core';
import { ModalConfig, ModalRef } from '@wfm/core';
import { TranslateService } from '@ngx-translate/core';
import { Logger, MessageService } from '@core/lib/services';
import { ProxyDataService } from '@app/core/http';
import { appConstants } from '@app/common/app-constants';
import { NotifyService } from '@app/common/notify.service';

const log = new Logger('PatientConfidentialComponent');

@Component({
  selector: 'app-patient-confidential',
  templateUrl: './patient-confidential.component.html'
})
export class PatientConfidentialComponent {
  isProcessing = false;
  constructor(
    public config: ModalConfig,
    public modalRef: ModalRef,
    private translate: TranslateService,
    private dataService: ProxyDataService,
    private notify: NotifyService,
    private messageService: MessageService
  ) {}

  onClose(value: boolean) {
    if (value) {
      this.isProcessing = true;
      const requestBody = {
        patientId: this.config.data.patientId,
        confidentialFlag: this.config.data.showConfidential,
        accessionNumber: this.config.data.auditInfo.accessionNumber,
        patientMRN: this.config.data.auditInfo.mrn,
        examId: this.config.data.auditInfo.examId
      };
      this.dataService
        .update(appConstants.appURLs.confidentialPatient, this.config.data.patientId, requestBody)
        .then(() => {
          const data = {
            patientId: this.config.data.patientId,
            patientConfidentialFlag: this.config.data.showConfidential === 1 ? 'Y' : 'N'
          };
          this.messageService.broadcast('patConfidentialStatusChange', data);
        })
        .catch(error => {
          log.error('Error updating Patient Confidential Status: ', error.toString());
          this.notify.error(this.translate.instant('context.patientStatusUpdateErrorMsg'));
        })
        .finally(() => {
          this.isProcessing = false;
          this.modalRef.close(value);
          this.messageService.broadcast('resetExamData');
        });
    } else {
      this.modalRef.close(value);
      this.messageService.broadcast('resetExamData');
    }
  }
}
